import { MenuItem } from "../models/menuItem.model";
import { UserRole } from "../../../enums/userRoles.enum";
import { AdminViewPath, ComparisionAnalysisPath, DashboardPath, AIAssistantPath, MovementEfficienyPath, RealTimeMapViewPath, UsageEfficienyPath, WorkingEfficienyPath, LoadEfficienyPath, RawDataPath, HeatmapPath, EfficiencySummaryPath, EfficiencySummaryV2Path, OperatorComparingSummaryPath, ShiftMovementSummaryPath, AlarmsPath, AlarmReportsPath, AlarmSetsPath, IndoorManagementPath, VenueManagementPath, TrnaslationsPath, BatteryPath, WorkingHoursPath, BulkForkliftPath, BulkDevicePath, BulkOperatorPath, BulkUserPath, BulkBatteryPath, EmailPath, AppConfigPath, GeofencingRegionManagementPath, AuditPath, AIConfigPath, MaintenanceLogPath, AppStatusPath, PlanningPath, OperatorSummaryPath, DailyEfficiencySummaryPath, UnauthorizedUsagePath, AiReportsPath, AiGuidePath, AiTokenUsagePath, SafetyPath, BreachPath, IndoorMapsPath } from "../../../../app/path"
import { Languages, BatteryCharging, Map, MapPin, MapPinHouse, Gauge, ChartNoAxesCombined, ChartColumn, Clock, Forklift, Percent, GitCompare, UsersRound, UserCog, Bell, BellElectric, Hash, List, Cog, UserCog2, FileArchive, Building, Building2, Hourglass, Shield, Battery, Users, HardHat, ForkliftIcon, Projector, Package, Mails, LucideShield, MapPinPlusInside, CassetteTape, Brain, Wrench, Siren, MessageCircle, User, ShieldAlert, FileText, BookOpen, CircleDollarSign, TrafficCone, BrickWall, ShieldXIcon, Layers } from 'lucide-react';

export const getMenus = (): MenuItem[] => {
    let i = 0;
    return [
        {
            id: ++i,
            link: DashboardPath,
            icon: Gauge,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: []
        },
        {
            id: ++i,
            label: "aiAssistant",
            icon: Brain,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: [
                {
                    id: ++i,
                    link: AIAssistantPath,
                    label: "aiChat",
                    icon: MessageCircle,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    requiredAiFeature: "AiAssistant",
                    children: []
                },
                {
                    id: ++i,
                    link: PlanningPath,
                    label: "aiPlanning",
                    icon: Brain,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    requiredAiFeature: "AiAssistant",
                    children: []
                },
                {
                    id: ++i,
                    link: AiReportsPath,
                    label: "aiReports",
                    icon: FileText,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: AiGuidePath,
                    label: "aiGuide",
                    icon: BookOpen,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                }
            ]
        },
        {
            id: ++i,
            label: "productivyAnalysis",
            icon: ChartNoAxesCombined,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: [
                {
                    id: ++i,
                    link: EfficiencySummaryPath,
                    icon: ChartColumn,
                    roles: [UserRole.SuperAdmin],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: EfficiencySummaryV2Path,
                    icon: ChartColumn,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: DailyEfficiencySummaryPath,
                    icon: ChartColumn,
                    roles: [UserRole.SuperAdmin],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    label: "detail",
                    icon: ChartNoAxesCombined,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: [
                        {
                            id: ++i,
                            link: WorkingEfficienyPath,
                            icon: Clock,
                            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                            isDisabled: false
                        },
                        {
                            id: ++i,
                            link: MovementEfficienyPath,
                            icon: Forklift,
                            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                            isDisabled: false
                        },
                        {
                            id: ++i,
                            link: UsageEfficienyPath,
                            icon: Percent,
                            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                            isDisabled: false
                        },
                        {
                            id: ++i,
                            link: LoadEfficienyPath,
                            icon: Package,
                            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                            isDisabled: false
                        },
                        {
                            id: ++i,
                            link: ComparisionAnalysisPath,
                            icon: GitCompare,
                            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                            isDisabled: false
                        },
                    ]
                }
            ]
        },
        {
            id: ++i,
            label: "mapOverview",
            icon: Map,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: [
                {
                    id: ++i,
                    link: RealTimeMapViewPath,
                    icon: MapPin,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: HeatmapPath,
                    icon: MapPinHouse,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: IndoorMapsPath,
                    icon: Layers,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
            ]
        },
        {
            id: ++i,
            label: "operatorAnalysis",
            icon: User,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: [
                {
                    id: ++i,
                    link: OperatorSummaryPath,
                    icon: Users,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: ShiftMovementSummaryPath,
                    icon: UserCog,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: OperatorComparingSummaryPath,
                    icon: GitCompare,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: true,
                    children: []
                },
                {
                    id: ++i,
                    link: UnauthorizedUsagePath,
                    icon: ShieldAlert,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                }
            ]
        },
                {
            id: ++i,
            label: "safetyModule",
            icon: ShieldXIcon,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: [
                {
                    id: ++i,
                    link: SafetyPath,
                    icon: Shield,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: BreachPath,
                    icon: TrafficCone,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                }
            ]
        },
        {
            id: ++i,
            label: "alarmsOverview",
            icon: Bell,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: [
                {
                    id: ++i,
                    link: AlarmReportsPath,
                    icon: BellElectric,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: true,
                    children: [],
                    hasNotificationBadge: true
                },
                {
                    id: ++i,
                    link: AlarmSetsPath,
                    icon: Hash,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: AlarmsPath,
                    icon: List,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                }
            ]
        },
        {
            id: ++i,
            link: MaintenanceLogPath,
            icon: Wrench,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: []
        },
        {
            id: ++i,
            link: BatteryPath,
            icon: BatteryCharging,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: []
        },
        {
            id: ++i,
            label: "admin",
            icon: Shield,
            roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
            isDisabled: false,
            children: [
                {
                    id: ++i,
                    link: WorkingHoursPath,
                    icon: Hourglass,
                    roles: [UserRole.SuperAdmin, UserRole.Admin, UserRole.User],
                    isDisabled: false,
                    children: []
                },
                {
                    id: ++i,
                    link: AdminViewPath,
                    icon: Cog,
                    roles: [UserRole.SuperAdmin, UserRole.Admin],
                    isDisabled: false,
                    children: []
                }
            ]
        },
        {
            id: ++i,
            label: "superAdmin",
            icon: UserCog2,
            roles: [UserRole.SuperAdmin],
            isDisabled: false,
            children: [
                {
                    id: ++i,
                    label: "fixers",
                    icon: Package,
                    roles: [UserRole.SuperAdmin],
                    isDisabled: false,
                    children: [
                        {
                            id: ++i,
                            link: RawDataPath,
                            icon: FileArchive,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: AppStatusPath,
                            icon: Siren,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: AppConfigPath,
                            icon: LucideShield,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: AIConfigPath,
                            icon: Brain,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: AiTokenUsagePath,
                            icon: CircleDollarSign,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        }
                    ]
                },
                {
                    id: ++i,
                    label: "portalManagement",
                    icon: Package,
                    roles: [UserRole.SuperAdmin],
                    isDisabled: false,
                    children: [
                        {
                            id: ++i,
                            link: AuditPath,
                            icon: CassetteTape,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: TrnaslationsPath,
                            icon: Languages,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: EmailPath,
                            icon: Mails,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        }
                    ]
                },
                {
                    id: ++i,
                    label: "mapManagement",
                    icon: Package,
                    roles: [UserRole.SuperAdmin],
                    isDisabled: false,
                    children: [
                        {
                            id: ++i,
                            link: VenueManagementPath,
                            icon: Building,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: IndoorManagementPath,
                            icon: Building2,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: GeofencingRegionManagementPath,
                            icon: MapPinPlusInside,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        }
                    ],
                },
                {
                    id: ++i,
                    label: "bulkData",
                    icon: Package,
                    roles: [UserRole.SuperAdmin],
                    isDisabled: false,
                    children: [
                        {
                            id: ++i,
                            link: BulkDevicePath,
                            icon: Projector,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: BulkForkliftPath,
                            icon: ForkliftIcon,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: BulkOperatorPath,
                            icon: HardHat,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: BulkUserPath,
                            icon: Users,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                        {
                            id: ++i,
                            link: BulkBatteryPath,
                            icon: Battery,
                            roles: [UserRole.SuperAdmin],
                            isDisabled: false,
                            children: []
                        },
                    ]
                }
            ]
        }
    ] as MenuItem[]
}
